import { PLAN_STATUS } from "./planStatus"

export const PLAN_STATUS_LABELS = {
  [PLAN_STATUS.CHOOSE_GUIDE]: "Choose Guide",
  [PLAN_STATUS.INVITE_STUDENT]: "Invite Student",
  [PLAN_STATUS.SIT_WITH_STUDENT]: "Student Activities",
  [PLAN_STATUS.INVITE_MENTORS]: "Invite Mentors",
  [PLAN_STATUS.SEND_PLAN]: "Mentor Activities",
  [PLAN_STATUS.CHECKLIST_COMPLETE]: "Plan Complete",
  [PLAN_STATUS.PLAN_COMPLETE]: "Plan Complete",
}

export const PLAN_STATUS_BADGE_VARIANTS = {
  [PLAN_STATUS.CHOOSE_GUIDE]: "locked",
  [PLAN_STATUS.INVITE_STUDENT]: "secondary",
  [PLAN_STATUS.SIT_WITH_STUDENT]: "waiting",
  [PLAN_STATUS.INVITE_MENTORS]: "primary",
  [PLAN_STATUS.SEND_PLAN]: "secondary-outline",
  [PLAN_STATUS.CHECKLIST_COMPLETE]: "success",
  [PLAN_STATUS.PLAN_COMPLETE]: "success",
}
